import { IAppeal } from 'feature/lkmAppeals/types'
import { FC } from 'react'
import styles from './LkmAppeal.module.scss'
import { CheckCircleOutline, ChevronRightRounded } from '@mui/icons-material'
import { formatPrice } from 'helpers/formatPrice'
import { Button } from '@mui/material'
import { getTimeByTimeZone } from 'helpers/date/getTimeByTimeZone'
import { convertDataToStringWithMonth } from 'helpers/date/convertDataToStringWithMonth'
import { Link } from 'react-router-dom'
import { Chip } from 'ui'
import { getAppealStatusChipData } from 'feature/lkmAppeals/config/AppealStatus'

interface ILkmAppeal {
  data: IAppeal
  handleOpen: () => void
}

const appealStatusCrm = [
  'C5:PREPAYMENT_INVOICE',
  'C5:UC_YHAZEV',
  'C5:LOSE',
  'C5:WON',
]

export const LkmAppeal: FC<ILkmAppeal> = ({ data, handleOpen }) => {
  const convertData = getTimeByTimeZone(data.installationDate)

  const isStatusChipVisible = appealStatusCrm.includes(data.statusCrm)
  const chipData = isStatusChipVisible
    ? getAppealStatusChipData[data.statusCrm]
    : null

  return (
    <Link
      className={styles.appeal}
      to={`/orders/${data.id}`}
      data-testid={`lkm-appeal-card-${data.id}`}
    >
      <div className={styles.appeal__header}>
        <h4>{data.name}</h4>
        <ChevronRightRounded color='primary' />
      </div>
      <div className={styles.appeal__body}>
        <div className={styles.appeal__param}>
          <span className={styles.appeal__paramTitle}>Дата:</span>
          <span className={styles.appeal__paramValue}>
            {convertDataToStringWithMonth(convertData, false, false)}
          </span>
        </div>
        <div className={styles.appeal__param}>
          <span className={styles.appeal__paramTitle}>Адрес:</span>
          <span className={styles.appeal__paramValue}>{data.address}</span>
        </div>
        <div className={styles.appeal__param}>
          <span className={styles.appeal__paramTitle}>Тип:</span>
          <span className={styles.appeal__paramValue}>{data.productType}</span>
        </div>
        {!!data.sum && (
          <div className={styles.appeal__param}>
            <span className={styles.appeal__paramTitle}>Сумма:</span>
            <span className={styles.appeal__paramValue}>
              {formatPrice(data.sum)}
            </span>
          </div>
        )}
        {data.status === 'new' && !data.responded && (
          <Button
            size='small'
            variant='contained'
            className={styles.appeal__button}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              handleOpen()
            }}
            data-testid={`lkm-appeal-respond-${data.id}`}
          >
            Откликнуться
          </Button>
        )}
        {data.status === 'new' && data.responded && (
          <div className={styles.appeal__responded}>
            <div className={styles.appeal__respondedText}>
              <CheckCircleOutline color='success' />

              <span>Отклик отправлен</span>
            </div>
          </div>
        )}

        {chipData && (
          <div className={styles.appeal__status}>
            <Chip status={chipData.status} label={chipData.label} />
          </div>
        )}
      </div>
    </Link>
  )
}
